module.exports = __webpack_public_path__ + "static/img/dayNx.5d5bed9c.png";